<app-webp type="skills" [name]="this.skill.iconName" [alt]="this.skill.iconName"></app-webp>
<p *ngIf="this.skill.description.trim() !== ''">{{ this.skill.description }}</p>
<div class="skill-header-container">
  <h2>{{ this.skill.name }}</h2>
</div>
